import { ViewSimpleSelect } from "../view/view-simple-select";
import { InteractionState } from "../abstract-interaction";
import { Feature, GeoJSON } from "geojson";

export class MeasureSimpleSelect extends ViewSimpleSelect<InteractionState> {

  buildInitialState(initialState: InteractionState): any {
    return {
      ...super.buildInitialState(initialState),
      useOutlineSelect: false,
    };
  }
}
